import React from 'react';
import { useStyles } from "../styles/styles";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
const InstallmentList = (props) => {
    const installments = props.installments;
    const classes = useStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const cellSx = {...classes.tableCell, fontSize: '.9rem', border: 'none', padding: '.3rem'};

    return (
        // TableContainer defaults to overflow-x:auto, which forces overflow-y to auto as
        // well, so a pixel of overhang gave every schedule its own vertical scroll bar.
        // Only phones need the sideways scroll; elsewhere let it overflow visibly, so
        // nothing (focus rings included) gets clipped.
        <TableContainer sx={{...classes.list, maxHeight: '100%', overflowX: {xs: 'auto', sm: 'visible'}, overflowY: {xs: 'hidden', sm: 'visible'}}}>
            <Table size="small" aria-label="Installment schedule">
                <TableHead>
                    <TableRow>
                        <TableCell component="th" scope="col" sx={{...cellSx, width: {xs: '17%', sm: '25%'}}}><span style={classes.visuallyHidden}>Select</span></TableCell>
                        <TableCell component="th" scope="col" sx={{...cellSx, width: '17%'}}>No.</TableCell>
                        <TableCell component="th" scope="col" sx={{...cellSx, width: '33%'}}>Due Date</TableCell>
                        <TableCell component="th" scope="col" sx={cellSx}>Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {installments && installments.length > 0 && installments.map((installment) => {
                        return (
                            <TableRow key={installment.priorityOrder}>
                                <TableCell sx={cellSx}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="pay"
                                                color='primary'
                                                sx={{paddingLeft: '.5rem', paddingBottom: '1rem'}}
                                                defaultChecked={false}
                                                onChange={(e) => {installment.checked = e.target.checked}}
                                                slotProps={{
                                                    input: {'aria-label': `Select installment ${installment.priorityOrder} due ${installment.dueDateDisplay}, amount ${installment.amountDisplay}`}
                                                }}
                                            />
                                        }
                                        label={smallScreen ? '' : 'Select'}
                                        sx={{...classes.checkbox, paddingLeft: '0'}}
                                    />
                                </TableCell>
                                <TableCell sx={cellSx}>{`${installment.priorityOrder}`}</TableCell>
                                <TableCell sx={cellSx}>{installment.dueDateDisplay}</TableCell>
                                <TableCell sx={{...cellSx, paddingLeft: '2rem'}}>{installment.amountDisplay}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default InstallmentList;
